"use client";

import api, { setAuthToken } from "@/lib/api/axios";
import { createContext, useContext } from "react";
import { useSession } from "next-auth/react";

const AxiosContext = createContext();

export function useAxios() {
  const context = useContext(AxiosContext);
  if (!context) {
    throw new Error("useAxios must be used within an AxiosProvider");
  }
  return context;
}

export default function AxiosProvider({ children, session: initialSession }) {
  const { data: session } = useSession();

  const currentSession = initialSession || session;

  // Sync the bearer token into the shared axios interceptor synchronously
  // during render. Doing this here (rather than in an effect) guarantees the
  // first request after a hard refresh is already authenticated — child mount
  // effects run before a parent provider's effect, so an effect-based approach
  // let those requests fire without a token and 401. The interceptor itself is
  // registered once at module load in axios.js; setAuthToken only swaps the
  // token value, so this is idempotent and safe to call every render.
  setAuthToken(currentSession?.accessToken);

  return <AxiosContext.Provider value={api}>{children}</AxiosContext.Provider>;
}
